// import {
// 	SpeciesInvasivityService,
// 	SpeciesNativityService,
// 	SpeciesTypeService,
// } from "../../Services";

import {ServiceDrivenAutoCompleteFieldEditor} from "./FieldEditors/ServiceDrivenAutoCompleteFieldEditor";
import {ServiceDrivenDropDownFieldEditor} from "./FieldEditors/ServiceDrivenDropDownFieldEditor";

import {service as ConservationActionService} from "../../Services/ConservationActionService";
import {service as ConservationActionTypeService} from "../../Services/ConservationActionTypeService";
import {service as ConfirmationAgencyService} from "../../Services/ConfirmationAgencyService";
import {service as ConfirmationStatusService} from "../../Services/ConfirmationStatusService";
import {service as ContactService} from "../../Services/ContactService";
// import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {service as EnvironmentalBenefitService} from "../../Services/EnvironmentalBenefitService";
import {service as EcoregionService} from "../../Services/EcoregionService";
import {service as HucService} from "../../Services/HucService";
import {service as PermitTypeService} from "../../Services/PermitTypeService";
import {service as PermitService} from "../../Services/PermitService";
import {service as ProcedureService} from "../../Services/ProcedureService";
import {service as ProgramService} from "../../Services/ProgramService";
import {service as ProjectService} from "../../Services/ProjectService";
import {service as RiverService} from "../../Services/RiverService";
// import {service as OrganizationService} from "../../Services/OrganizationService";
import {service as SpeciesListService} from "../../Services/SpeciesListService";
import {service as StakeholderTypeService} from "../../Services/StakeholderTypeService";
import {service as TagService} from "../../Services/TagService";
import {ServiceDrivenCheckboxesFieldEditor} from "./FieldEditors/ServiceDrivenCheckboxesFieldEditor";
// import {OrganizationFieldEditor} from "./FieldEditors/OrganizationFieldEditor";


export const ContactFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ContactService);

// there is a special component for this
export {ContextNodeFieldEditor} from './FieldEditors/ContextNodeFieldEditor'
export const ConservationActionFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ConservationActionService);
export const ConfirmationAgencyEditor = ServiceDrivenAutoCompleteFieldEditor(ConfirmationAgencyService);
export const ConfirmationStatusEditor = ServiceDrivenAutoCompleteFieldEditor(ConfirmationStatusService);
export const HucFieldEditor = ServiceDrivenAutoCompleteFieldEditor(HucService);
export const RiverFieldEditor = ServiceDrivenAutoCompleteFieldEditor(RiverService);
export const EcoregionFieldEditor = ServiceDrivenAutoCompleteFieldEditor(EcoregionService);
export const TagFieldEditor = ServiceDrivenAutoCompleteFieldEditor(TagService);

export * from './SpeciesFieldComponents';

export { SpeciesListFieldEditor } from './FieldEditors/SpeciesListFieldEditor';

export const EnvironmentalBenefitFieldEditor = ServiceDrivenAutoCompleteFieldEditor(EnvironmentalBenefitService);

export const PermitFieldEditor = ServiceDrivenAutoCompleteFieldEditor(PermitService);
export const PermitTypeFieldEditor = ServiceDrivenAutoCompleteFieldEditor(PermitTypeService);

export const ProcedureFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ProcedureService);

export const ProgramAutoCompleteFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ProgramService);

export const ProjectFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ProjectService);
export const StakeholderTypeEditor = ServiceDrivenDropDownFieldEditor(StakeholderTypeService);
export const ConservationActionTypeFieldEditor = ServiceDrivenDropDownFieldEditor(ConservationActionTypeService);

// TODO: see if this can be replaced with the ServiceDrivenAutoCompleteFieldEditor or
// ServiceDrivenDropDownFieldEditor
export {OrganizationFieldEditor} from './FieldEditors/OrganizationFieldEditor';


export const SpeciesListCheckboxFieldEditor = ServiceDrivenCheckboxesFieldEditor(SpeciesListService);
